import React from 'react';
import './App.scss';
import HeaderNavbar from './components/Navbar/Navbar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import User from './components/User/User';
import Contact from './components/Contact/Contact';
import Cart from './components/Cart/Cart';
import Verify from './components/Verify/Verify';
import EnvComponent from './components/EnvComponent/EnvComponent';
import Empty from './components/Empty/Empty';
import ThankYou from './components/ThankYou/ThankYou';
import LeftMenuContextProvider from './contexts/login.context';
import useLoader from './contexts/LoaderContext';
import './i18n/config';
import I18nLocaleSync from './i18n/I18nLocaleSync';
import LocalizationProvider from './contexts/LocalizationContext';
import TestPDP from './components/TestPDP/TestPDP';

// Layout component that includes HeaderNavbar and Footer
const AppLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <HeaderNavbar />
      {children}
      <Footer />
    </>
  );
};

function App() {
  const isVerify: boolean = false;
  const isThanks: boolean = false;
  const { isBodyLoading } = useLoader();
  const initialValidationErrors: Record<string, string> = {};
  return (
    <div className={isBodyLoading ? "loading App" : "App"}>
      <BrowserRouter>
        <I18nLocaleSync />
        <LocalizationProvider>
          <LeftMenuContextProvider>
            <Routes>
              <Route path="*" element={<AppLayout><EnvComponent /></AppLayout>}></Route>
              <Route path=":locale/pdp" element={<AppLayout><TestPDP /></AppLayout>}></Route>
              <Route path=":locale/cart" element={<AppLayout><EnvComponent /></AppLayout>}></Route>
              <Route path=":locale/cart/empty" element={<AppLayout><Empty /></AppLayout>}></Route>
              <Route path=":locale/cart/view" element={<AppLayout><Cart onCartChange={(e) => { }} validationErrors={initialValidationErrors} onPromoChange={(e) => { }} onPromoSubmit={(e) => { }} onPromoDelete={(e) => { }} isVerify={isVerify} isThanks={isThanks} cartData={''} promoCodeError={false} /></AppLayout>}></Route>
              <Route path=":locale/cart/user" element={<AppLayout><User /></AppLayout>}></Route>
              <Route path=":locale/cart/user/:userType" element={<AppLayout><User /></AppLayout>}></Route>
              <Route path=':locale/cart/verify/' element={<AppLayout><Verify /></AppLayout>}></Route>
              <Route path=":locale/cart/contact" element={<AppLayout><Contact /></AppLayout>}></Route>
              <Route path=":locale/cart/thankyou" element={<AppLayout><ThankYou /></AppLayout>}></Route>
            </Routes>
          </LeftMenuContextProvider>
        </LocalizationProvider>
      </BrowserRouter>
      <div className="overlay"><div className="center-ovelay"><div className="swg-spinner-wrapper"><div className="swg-spinner"></div></div></div></div>
    </div >
  );
}

export default App;
